import React, { useEffect, useState } from "react";
import { debounce } from "lodash";
import { set_snack_bar } from "actions/snackbar/snackbar_action";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const Location = ({
  option,
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  const fetchLocations = debounce(async (query) => {
    if (!query?.trim()) return;
    try {
      setLoading(true);
      const response = await fetch(
        `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
          query
        )}&apiKey=6c147cbfca9e4f768c57f8fc6a1e7642`
      );
      const result = await response.json();
      setOptions(result?.features || []);
    } catch (error) {
      set_snack_bar(true, "Could not find the location.");
    } finally {
      setLoading(false);
    }
  }, 500);

  const handleChange = (type, value) => {
    let updatedValue = inputValue;
    let updatedComment = commentBox;
    let updatedDoc = attachDocument;

    if (type === "location") {
      updatedValue = value;
      setInputValue(value);

      if (!value?.trim()) {
        setOptions([]);
      } else {
        fetchLocations(value);
      }
    } else if (type === "comment") {
      updatedComment = value;
      setCommentBox(value);
    } else if (type === "document") {
      updatedDoc = value;

      setAttachDocument(value);
    }

    if (isFrom === "taskSection") {
      const obj = {
        value: updatedValue,
        comment: updatedComment,
        weightage: 1,
        supporting_document:
          type === "document" && value === null ? value : updatedDoc,
        document: type === "document" ? value : updatedDoc,
        documentMetaData:
          type === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  const handleValue =
    inputValue ||
    submittedAnswer?.value ||
    submittedAnswer?.answer ||
    responseAnswer ||
    "";
  useEffect(() => {
    if (submittedAnswer) {
      const answerObj = Array.isArray(submittedAnswer)
        ? submittedAnswer[0]
        : submittedAnswer;

      setInputValue(answerObj?.value || "");
      setCommentBox(answerObj?.comment || "");
      setAttachDocument(answerObj?.supporting_document || null);
    }
  }, []);

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
        mt: 2,
      }}
    >
      <Autocomplete
        freeSolo
        options={options}
        getOptionLabel={(option) => option?.properties?.formatted || ""}
        inputValue={handleValue}
        onInputChange={(e, value) => handleChange("location", value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={submittedAnswer ? "" : "Search Location"}
            variant="outlined"
            size="small"
            placeholder="Enter the location"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {!submittedAnswer && params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      {comment && (
        <Box sx={{ pointerEvents: event, mt: 1.5 }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default Location;
